import React from 'react';
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { styles } from '@tag/tag-components-react-v2';
import { Story } from '../../Docs/DocTypes';
import { getCssForStoryTitleButton } from './NavUtils';
type NavGroupItemProps = {
  story: Story;
  selected: boolean;
  onClick: (story: Story) => void;
  docsDarkModeValue: boolean;
};
export const NavGroupItem: React.FC<NavGroupItemProps> = (props: NavGroupItemProps) => (
  <button
    css={getCssForStoryTitleButton(props.selected, styles.font.family, props.docsDarkModeValue)}
    onClick={() => props.onClick(props.story)}
    title={props.story.title}
  >
    {props.story.title}
  </button>
);
